import React from "react";
import { TextField, Typography } from "@mui/material";
import { useField } from "formik";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en"; // Import English locale
import "dayjs/locale/de"; // Import German locale
import localizedFormat from "dayjs/plugin/localizedFormat"; // Import plugin for localized date formats
dayjs.extend(localizedFormat);
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
const InputField = ({
  name,
  variant,
  onChange,
  width,
  type = "text",
  maxLength,
  dateFormatProp,
  value,
  transKey,
  ...rest
}) => {
  const [field, mata, helpers] = useField(name);
  const initialValue = value ? value : field.value ? field.value : ""; // Use an empty string as the default value

  const { t, i18n } = useTranslation();
  const language = i18n.language;
  dayjs.locale(language);
  const dateFormat = dateFormatProp || "DD MMMM YYYY";
  useEffect(() => {
    dayjs.locale(language);
  }, [language]);
  useEffect(() => {
    if (type === "date" && rest.value) {
      helpers.setValue(dayjs(rest.value).toISOString());
    }
  }, [rest.value, type, helpers]);
  const textFieldConfig = {
    ...field,
    fullWidth: true,
    variant: variant ? variant : "standard",
    margin: "dense",
    ...rest,
    value: initialValue, // Always set a controlled value
    type: type,
    // ...otherProps,
  };

  if (mata && mata?.touched && mata?.error) {
    textFieldConfig.error = true;
    textFieldConfig.helperText = mata.error;
  }

  return (
    <>
      {type === "date" ? (
        <>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={i18n?.language}
          >
            <DatePicker
              label={t(`${transKey || 'input-2'}`)}
              className="date-feild"
              value={value ? dayjs(value) : field.value ? dayjs(field.value) : null}
              onChange={(date) => {
                helpers.setValue(new Date(date.toDate().setHours(10, 0, 0, 0)).toISOString());
                onChange && onChange(new Date(date.toDate().setHours(10, 0, 0, 0)).toISOString())
              }}
              slotProps={{ textField: { variant: "standard" } }}
              inputProps={{
                style: { border: "none !important" }, // Add this to remove the border
              }}
              format={dateFormat} // Use the defined date format
              renderInput={(params) => (
                <TextField
                  {...params}
                  className="date-feild"
                  type="date"
                  placeholder={dateFormat} // Use the defined date format as placeholder
                  onFocus={(e) => (e.target.type = "date")}
                  inputProps={{
                    style: { border: "none !important" }, // Add this to remove the border
                  }}
                />
              )}
            />
          </LocalizationProvider>
          {mata.error && (
            <Typography variant="caption" color="error">
              {mata.error}
            </Typography>
          )}
        </>
      ) : (
        <TextField
          inputProps={{
            maxLength: maxLength,
          }}
          sx={{
            width: `${width} !important`,
            "& .MuiInput-underline.Mui-disabled:before": {
              borderBottomStyle: "solid",
            },
            "& .MuiInputBase-root.Mui-disabled": {
              backgroundColor: "white !important",
            },
            "& .MuiInputLabel-root.Mui-disabled": {
              backgroundColor: "white !important",
              color: "#444561 !important",
            },
          }}
          {...textFieldConfig}
        />
      )}
    </>
  );
};

export default InputField;
